import React, { useState, useEffect, Fragment } from 'react'
import { Confirm, useTranslate, useNotify } from 'react-admin'
import {
  Grid,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Checkbox,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Skeleton,
  Autocomplete,
  Typography,
  FormControlLabel,
  Tooltip,
  CircularProgress,
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import EditIcon from '@mui/icons-material/Edit';
import LoadingButton from '@mui/lab/LoadingButton'
import { SwitchInput } from 'src/components/uiElements/fields/SwitchInput'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_CREATE, PERMISSION_DELETE } from 'src/helper/Permission'
import { Delete, Edit, Save } from '@mui/icons-material'
import { CANCELLED } from '../common/state'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { useErrorHandler } from 'src/hooks/useErrorHandler'
import { CreditNote } from './logic/CreditNote'
import ReceiptIcon from '@mui/icons-material/Receipt'
import { PaymentSupplierDialog } from './logic/PaymentSupplierDialog'
import {parseDateFormat} from 'src/helper/parseDateFormat'
import RefreshIcon from '@mui/icons-material/Refresh';
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { itemServices } from 'src/services/reservation/item/item.service'
import { BillingNumberDialog } from './logic/BillingNumberDialog'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'


export const BillingReservation = ({ reservation }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [status, setStatus] = useState(['', ''])
  const [client, setClient] = useState()
  const [loadingClient, setLoadingClient] = useState(false)
  const [sale, setSale] = useState()
  const [loadingSales, setLoadingSales] = useState(false)
  const [pendingItems, setPendingItems] = useState([])
  const [loadingItems, setLoadingItems] = useState(false)
  const [itemsToBill, setItemsToBill] = useState({})
  const [billingNumberModal, setBillingNumberModal] = useState(false)
  const [itemIdToEdit, setItemIdToEdit] = useState()
  const [loadingItemsToBill, setLoadingItemsToBill] = useState(false)
  const [updatingItemsToDelete, setUpdatingItemsToDelete] = useState(false)
  const [loadingItemsToDelete, setLoadingItemsToDelete] = useState(false)
  const [invoices, setInvoices] = useState([])
  const [loadingInvoices, setLoadingInvoices] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [modalData, setModalData] = useState({})
  const [openSaleModal, setOpenSaleModal] = useState(false)
  const [saleFormData, setSaleFormData] = useState({})
  const [errorSale, setErrorSale] = useState(false)
  const [errorItems, setErrorItems] = useState(false)
  const [updatingItemsToBill, setUpdatingItemsToBill] = useState(false)
  const [importingInvoice, setImportingInvoice] = useState(false)
  const [selectedItemsToBill, setSelectedItemsToBill] = useState([])
  const [updatingInvoices, setUpdatingInvoices] = useState(false)
  const [selectedInvoices, setSelectedInvoices] = useState([])
  const [statusSale, setStatusSale] = useState(true)
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false)
  const [openCreditNoteModal, setOpenCreditNoteModal] = useState(false)
  const [invoiceForm, setInvoiceForm] = useState({})
  const [selectAll, setSelectAll] = useState(false)
  const [selectAllToBill, setSelectAllToBill] = useState(false)
  const [checkedDeleteBusinessInTMA, setCheckedDeleteBusinessInTMA] = useState(false)
  const [basesList, setBasesList] = useState({})
  const [loadingBasesList, setLoadingBasesList] = useState(false)

  const addError = useErrorHandler()
  const [loadingCreditNote, setLoadingCreditNote] = useState(false)
  const [creditNoteForm, setCreditNoteForm] = useState({})

  const [paymentSupplierDialog, setPaymentSupplierDialog] = useState(false)
  const [paymentsOrder, setPaymentsOrder] = useState([])
  const [orderRefrehLoading, setOrderRefresh] = useState(false)
  const [confirmDeleteRequirement, setConfirmDeleteRequirement] = useState(false)
  const [confirmDeleteReq, setConfirmDeleteReq] = useState(false)
  const [loadingDeleteReq, setLoadingDeleteReq] = useState(false)
  const [reqToDelete, setReqToDelete] = useState(null)
  const [reloadItemsToBill, setReloadItemsToBill] = useState(false)
  const [editBusinessNumber, setEditBusinessNumber] = useState(false)
  const [businessEditedNumber, setBusinessEditedNumber] = useState(null)
  const [editBusinessNumberLoading, setEditBusinessNumberLoading] = useState(false)

  const NOTA_DE_CREDITO__A_ID = 6
  const NOTA_DE_CREDITO__B_ID = 7
  const [isSupplierOrder, setIsSupplierOrder] = useState(true)

  const [openBusinessItemsConfirm, setOpenBuisenessItemsConfirm] = useState(false)
  const [businessItemsLoading, setBusinessItemsLoading] = useState(false)
  const [businessItemsConfirm, setBusinessItemsConfirm] = useState(false)

  const onInitBusinessItems = async ()=>{
    setBusinessItemsLoading(true)
    await reservationServices.generateBusinessItems(reservation.id).then(()=>{
      onSuccess('ra.notification.created_success_sale_reservation')
    }).catch(()=>{
      onError('ra.notification.created_error_sale_reservation')
      setErrorSale(true)
    }).finally(()=>{
      setBusinessItemsConfirm(false)
      setBusinessItemsLoading(false)
      setOpenBuisenessItemsConfirm(false)
      checkSale()
      /* setReloadItemsToBill(reload=>!reload) */
    })
  }

  useEffect(()=>{
    if(businessItemsConfirm){
      onInitBusinessItems()
    }
  },[businessItemsConfirm])
  
  const getSupplierPaymentOrder = async () =>{
    setOrderRefresh(true)
    await reservationServices.get_payment_order(reservation.number).then(res=>{
      setPaymentsOrder(res.data)
    }).finally(()=>{
      setOrderRefresh(false)
    })
  }

  useEffect(() => {
    getSupplierPaymentOrder()
    checkClient()
    getBases()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadItemsToBill])

  useEffect(() => {
    setSelectAll(pendingItems?.items?.length > 0 && selectedItems.length === pendingItems.items.length);
  }, [selectedItems, pendingItems]);

  useEffect(() => {
    setSelectAllToBill(itemsToBill?.items?.length > 0 && selectedItemsToBill.length === itemsToBill.items.length);
  }, [selectedItemsToBill, itemsToBill]);

  const onEditBusinessNumber = async () =>{
    setEditBusinessNumberLoading(true)
    await businessUnitServices.editBusinessNumber(businessEditedNumber, sale[0].id).then(()=>{
      notify('ra.notification.edit_business_number_success', {type:'success'})
      setEditBusinessNumber(false)
      checkSale()
    }).catch(()=>{
      notify('ra.notification.edit_business_number_error', {type:'error'})
    }).finally(()=>{
      setEditBusinessNumberLoading(false)
    })
  }

  const onSuccess = (notification, messageArgs) => {
    notify(`${notification}`, {
      type: 'success',
      messageArgs: messageArgs ? { element: translate(`${messageArgs}`) } : {},
    })
  }

  useEffect(()=>{
    if(confirmDeleteReq){
      setLoadingDeleteReq(true)
      itemServices.deletePaymentOrder(reqToDelete).then(()=>{
        setConfirmDeleteRequirement(false)
        notify('ra.message.delete_requirement_success',
          {type:'success'}
        
        )
        getSupplierPaymentOrder()
      })
      .catch(()=>{
        notify('ra.message.delete_requirement_error',
          {type:'error'}
        
        )
      }).finally(()=>{
        setLoadingDeleteReq(false)
      })
    }
  },[confirmDeleteReq])

  const onError = (notification, messageArgs) => {
    notify(`${notification}`, {
      type: 'error',
      messageArgs: messageArgs ? { element: translate(`${messageArgs}`) } : {},
    })
  }

  const getBases = async () => {
    if (reservation.business_unit_id) {
      setLoadingBasesList(true)
      try {
        const allBases = await reservationServices.getAllBases(reservation.business_unit_id)
        if (allBases) {
          setBasesList(allBases)
          setLoadingBasesList(false)
          if (openSaleModal) {
            handleChangeSaleForm('baseToBilling', allBases?.selected || '')
          }
          return
        }
        notify(`bases not found`, { type: 'error' })
        setLoadingBasesList(false)
      } catch (error) {
        notify(`please, refresh page`, { type: 'error' })
        setLoadingBasesList(false)
      }
    }
  }

  const checkClient = async () => {
    if (reservation.business_unit_id) {
      setLoadingClient(true)
      const clientResponse = await reservationServices
        .checkClient(reservation.business_unit_id)
        .catch((e) => {
          setClient(null)
          setLoadingClient(false)
        })
      if (clientResponse && clientResponse['System response'].Exists === 'true') {
        setClient(clientResponse['B2 DDBB response'].client_info[0])
      }
      checkSale()
      setLoadingClient(false)
    }
  }

  const onCheckSale = async () =>{
    setLoadingSales(true)
    const saleResponse = await reservationServices.checkSale(reservation.id).catch((e) => {
      setSale(null)
    }).finally(()=>{
      setLoadingSales(false)
    })
    if (saleResponse) {
      setStatusSale(!saleResponse['B2 DDBB response']?.status?.includes('REVIEW'))
      const sales =
        !saleResponse['B2 DDBB response'] || Array.isArray(saleResponse['B2 DDBB response'])
          ? saleResponse['B2 DDBB response']
          : [saleResponse['B2 DDBB response']]
      const filteredSales = sales?.filter((elem) => elem !== null) || []
      setSale(filteredSales.length > 0 ? filteredSales : null)
    }
  }

  const checkSale = async () => {
    if (reservation.id) {
      onCheckSale()
      getInvoices()
      getItems()
    }
  }

  const getItems = async () => {
    setLoadingItems(true)
    const allItems = await reservationServices.getItems(reservation.id).catch((e) => setItemsToBill({})).finally(()=>{
      setLoadingItems(false)
    })
    if (allItems) {
      setPendingItems({
        items: allItems.item_pending || [],
        total_amount: allItems.total_amount_pending || 0,
        total_cost: allItems.total_cost_pending || 0,
      })
      setItemsToBill({
        items: allItems.item_facturacion || [],
        total_amount: allItems.total_amount_facturacion || 0,
        total_cost: allItems.total_cost_facturacion || 0,
      })
    }
  }

  const getInvoices = async () => {
    setLoadingInvoices(true)
    const allInvoices = await reservationServices.getInvoices(reservation.id).catch((e) => {
      setInvoices([])
    }).finally(()=>{
      setLoadingInvoices(false)
    })
    if (allInvoices) {
      setInvoices(allInvoices)
    }
  }

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      setSelectedItems(pendingItems.items);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectAllToBill = (e) => {
    const checked = e.target.checked;
    setSelectAllToBill(checked);
    if (checked) {
      setSelectedItemsToBill(itemsToBill.items.map(item => item.hash_item));
    } else {
      setSelectedItemsToBill([]);
    }
  };

  const handleSelectItem = (item, checked) => {
    let selectedItemsAux = [...selectedItems]
    if (checked) {
      selectedItemsAux.push(item)
    } else {
      selectedItemsAux = selectedItemsAux.filter((elem) => elem.id !== item.id)
    }
    setSelectedItems(selectedItemsAux)
  }

  const getInvoiceTitle = (invoice) => {
    const date = invoice.created_at ? new Date(invoice.created_at).toLocaleDateString() : null

    return (
      <Fragment>
        <div>
          <div style={{display:'flex', flexDirection:'row'}}>
            <span>
              <b style={{ marginRight: 20 }}>
              {invoice?.voucher_type_name} #{invoice?.invoice_ref}
              </b>
              {invoice.CAE && <b style={{ marginLeft: 20 }}>
                {invoice.CAE}
              </b>}
            </span>
          </div>
          <div style={{display:'flex', flexDirection:'row'}}>
            {date ? (
              <b /* style={{ marginLeft: 20 }} */>
                <span className='gray'>{translate('ra.field.date')}: </span> {date}
              </b>
            ) : (
              ''
            )}
            <b style={{ marginLeft: 20 }}>
              <span className='gray'> {translate('ra.field.total')}: </span> {invoice.currency}{' '}
              {numberFormatterWithDecimalAndThousand(invoice.total_amount)}
            </b>
            {invoice?.currency_value !== null && invoice?.currency_value !== undefined && (
              <b style={{ marginLeft: 20 }}>
                <span className='gray'> {translate('ra.field.change_type')}: </span>
                {invoice.currency_value}
              </b>
            )}
          </div>
        </div>
        
        
      </Fragment>
    )
  }

  const handleOpenConfirmationModal = (
    title,
    onConfirm,
    onClose = null,
    content = null,
    confirmText = null,
    cancelText = null,
    contentLogic = false
  ) => {
    setOpenSaleModal(false)
    setOpenInvoiceModal(false)
    setOpenConfirmationModal(true)
    let data = { title, onConfirm, onClose, content, confirmText, cancelText }
    if (contentLogic){
      data.contentLogic = contentLogic
    } 
    setModalData(data)
  }

  const handleOpenCurrencyModal = (title, onConfirm, autoBill = false) => {
    setOpenSaleModal(true)
    setSaleFormData({
      isBerlin: false,
      baseToBilling: basesList?.selected || '',
    })
    setModalData({
      title,
      onConfirm,
      autoBill,
    })
  }

  const handleInitCompleteProcess = async (formData) => {
    try {
      setLoadingSales(true)
      const dataToSend = {
        reservation_id: reservation.id,
        currency: formData?.currency,
        base_b: formData?.isBerlin,
        base_to_billing: formData?.baseToBilling || '',
        item_id: pendingItems.items.map((item) => item.id),
      }
      const response = await reservationServices.initCompleteProcess(dataToSend)
      if (response && !response.Errors && response.Sale && response.Invoice) {
        const sales = (sale || []).filter((elem) => elem.id !== response.Sale.id)
        setSale([...sales, response.Sale])
        setPendingItems({
          items: [],
          total_amount: 0,
          total_cost: 0,
        })
        setInvoices((current) => [...current, response.Invoice])
        onSuccess('ra.notification.success_full_process')
        return
      }
      onError('ra.notification.error_full_process')
    } catch (error) {
      onError('ra.notification.error_full_process')
    } finally {
      setOpenConfirmationModal(false)
      setLoadingSales(false)
      setOpenSaleModal(false)
    }
  }

  const handleGenerateClient = async () => {
    setLoadingClient(true)
    const clientResponse = await reservationServices
      .generateClient(reservation.business_unit_id)
      .catch((e) => {
        setClient(null)
        setLoadingClient(false)
      })
    if (clientResponse) {
      setClient(clientResponse['B2 DDBB response'])
    }
    setOpenConfirmationModal(false)
    setLoadingClient(false)
  }

  const handleGenerateSale = async (saleFormData) => {
    try {
      setLoadingSales(true)
      const dataToSend = {
        reservation_id: reservation.id,
        currency: saleFormData?.currency,
        base_b: saleFormData?.isBerlin,
        base_to_billing: saleFormData?.baseToBilling || '',
      }
      if (saleFormData?.saleNumber) {
        dataToSend['sale_id'] = saleFormData?.saleNumber
      }
      const saleResponse = await reservationServices.generateSale(dataToSend)
      if (saleResponse) {
        setSale(
          !saleResponse['B2 DDBB response'] || Array.isArray(saleResponse['B2 DDBB response'])
            ? saleResponse['B2 DDBB response']
            : [saleResponse['B2 DDBB response']]
        )
        getItems()
        setErrorSale(false)
        onSuccess('ra.notification.created_success_sale_reservation')
        return
      }
      onError('ra.notification.created_error_sale_reservation')
      setErrorSale(true)
    } catch (error) {
      setSale(null)
      setErrorSale(true)
      addError(error, () => onError('ra.notification.created_error_sale_reservation'))
    } finally {
      setOpenConfirmationModal(false)
      setLoadingSales(false)
      setOpenSaleModal(false)
    }
  }

  const handleDeleteSale = async (checkedDeleteBusinessInTMA) => {
    try {
      setLoadingSales(true)
       const saleResponse = await reservationServices.deleteSale(reservation.number, {
         void: checkedDeleteBusinessInTMA,
       })
      if (saleResponse) {
        setSale(null)
        getItems()
        onSuccess('ra.notification.deleted_success_sale_reservation')
        return
      }
      onError('ra.notification.deleted_error_sale_reservation')
    } catch (error) {
      addError(error, () => onError('ra.notification.deleted_error_sale_reservation'))
    } finally {
      setOpenConfirmationModal(false)
      setLoadingSales(false)
      setCheckedDeleteBusinessInTMA(false)
    }
  }

  const getBaseToBilling = (sale) => {
    try {
      if (Array.isArray(sale) && sale.length == 1) {
        // si hay un solo elemento obtenemos el valor de ese
        return sale?.[0]?.base
      }
      if (Array.isArray(sale) && sale.length > 1) {
        const sale_found = sale.find((elem) => elem.base !== 'TIJEBERLIN') // si hay mas de uno tomamos el que es diferente de TIJEBERLIN (asumiendo que hay 2 como maximo)
        if (sale_found) {
          return sale_found?.base
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  const handleAddItem = async () => {
    const isBaseB = sale.find((elem) => elem.base === 'TIJEBERLIN') ? true : false
    const base_to_billing = getBaseToBilling(sale)
    setLoadingItemsToBill(true)
    const itemsIds = selectedItems.map((elem) => elem.id)
    const response = await reservationServices.addItem(itemsIds, isBaseB, base_to_billing).catch((e) => {
      const statusAux = [...status]
      statusAux[0] = 'NO AGREGADO'
      statusAux[1] = ''
      setStatus(statusAux)
      setLoadingItemsToBill(false)
      setOpenConfirmationModal(false)
      addError(e, () => onError('ra.notification.created_error_add_items_reservation'))
    })
    if (response) {
      setSelectedItems([])
      setLoadingItems(true)
      getItems()

      const statusAux = [...status]
      statusAux[0] = 'AGREGADO'
      statusAux[1] = ''
      setStatus(statusAux)
      setErrorItems(false)
      onSuccess('ra.notification.created_success_add_items_reservation')
    } else {
      setErrorItems(true)
      onError('ra.notification.created_error_add_items_reservation')
    }
    setOpenConfirmationModal(false)
    setLoadingItemsToBill(false)
  }

  const handleImportInvoice = async () => {
    setLoadingInvoices(true)
    const dataToSend = selectedItemsToBill.map((hash_item) => ({
      number: reservation.number,
      CAE:invoiceForm.CAE,
      invoice_reference: invoiceForm?.invoice_reference,
      glosa: invoiceForm?.glosa || null,
      currency_value:
        invoiceForm?.currency_value !== undefined && invoiceForm?.currency_value !== ''
          ? Number(invoiceForm?.currency_value)
          : null,
      hash_item,
      system_code: client.code,
    }))

    const response = await reservationServices.importInvoice(dataToSend).catch((e) => {
      const statusAux = [...status]
      statusAux[0] = ''
      statusAux[1] = 'NO FACTURADO'
      setStatus(statusAux)
    })
    if (response && response['B2 DDBB response']) {
      const invoicesAux = Array.isArray(response['B2 DDBB response'])
        ? response['B2 DDBB response']
        : [response['B2 DDBB response']]
      setInvoices([...invoices, ...invoicesAux])

      const itemsToBillAux =
        itemsToBill?.items?.filter((elem) => !selectedItemsToBill.includes(elem.hash_item)) || []
      setItemsToBill({
        items: itemsToBillAux,
        total_amount: itemsToBillAux.reduce((acc, current) => acc + current.amount, 0),
        total_cost: itemsToBillAux.reduce((acc, current) => acc + current.cost, 0),
      })

      const statusAux = [...status]
      statusAux[0] = ''
      statusAux[1] = 'FACTURADO'
      setStatus(statusAux)
    }
    setImportingInvoice(false)
    setOpenConfirmationModal(false)
    setLoadingInvoices(false)
    setSelectedItemsToBill([])
  }

  const handleGenerateInvoice = async () => {
    setLoadingInvoices(true)
    const dataToSend = {
      reservation_id: reservation.id,
      glosa: invoiceForm?.glosa || null,
      currency_value:
        invoiceForm?.currency_value !== undefined && invoiceForm?.currency_value !== ''
          ? Number(invoiceForm?.currency_value)
          : null,
      document_branch_number:
        invoiceForm?.document_branch_number !== undefined && invoiceForm?.document_branch_number !== ''
          ? Number(invoiceForm?.document_branch_number)
          : null,
    }
    const response = await reservationServices.generateInvoice(dataToSend).catch((e) => {
      const statusAux = [...status]
      statusAux[0] = ''
      statusAux[1] = 'NO FACTURADO'
      setStatus(statusAux)
      addError(e)
    })
    if (response && response['B2 DDBB response']) {
      const invoicesAux = Array.isArray(response['B2 DDBB response'])
        ? response['B2 DDBB response']
        : [response['B2 DDBB response']]
      setInvoices([...invoices, ...invoicesAux])
      setItemsToBill({})

      const statusAux = [...status]
      statusAux[0] = ''
      statusAux[1] = 'FACTURADO'
      setStatus(statusAux)
    }
    setOpenConfirmationModal(false)
    setLoadingInvoices(false)
    setSelectedItemsToBill([])
  }

  const handleGenerateInvoiceAux = async () => {
    if (importingInvoice) {
      handleImportInvoice()
    } else {
      handleGenerateInvoice()
    }
  }

  const sortSales = (a, b) => {
    const regex = /^[A-Za-z]/ // Expresión regular para verificar si una cadena comienza con una letra
    const startsWithLetterA = regex.test(a)
    const startsWithLetterB = regex.test(b)

    if (startsWithLetterA && !startsWithLetterB) {
      return 1
    } else if (!startsWithLetterA && startsWithLetterB) {
      return -1
    } else {
      return 0
    }
  }

  const getSaleId = () => {
    if (errorSale && !sale) {
      return 'Revisar creación en TMA'
    } else if (sale) {
      const sales = sale.map((elem) => {
        if (elem?.base?.toLowerCase().includes('berlin')) {
          return `B${elem.sale_id}`
        }

        return elem.sale_id
      })
      sales.sort(sortSales)
      return sales.join('-')
    }

    return 'PENDIENTE'
  }

  useEffect(()=>{
    if(sale?.length > 0){
      setBusinessEditedNumber(sale[0]?.sale_id ? Number(sale[0]?.sale_id) : null)
    }
  },[sale])

  const handleConfirmCreationSale = async (confirmed) => {
    if (confirmed) {
      setLoadingSales(true)
      const saleResponse = await reservationServices.confirmSale(reservation.number, true)
      if (saleResponse) {
        const sales = Array.isArray(saleResponse) ? saleResponse : [saleResponse]
        setSale(sales.filter((elem) => elem !== null))
        getItems()
      }
      setLoadingSales(false)
    }
    setOpenConfirmationModal(false)
    setErrorSale(false)
    setSaleFormData({})
  }

  const handleConfirmAddItems = async (confirmed) => {
    if (confirmed) {
      setLoadingItemsToBill(true)
      const itemsHash = selectedItems.map((elem) => elem.hash_)
      const itemsResponse = await reservationServices.confirmItems(reservation.number, itemsHash)
      if (itemsResponse && !itemsResponse['Warning']) {
        getItems()
        const statusAux = [...status]
        statusAux[0] = 'AGREGADO'
        statusAux[1] = ''
        setStatus(statusAux)
        setSelectedItems([])
      } else {
        const statusAux = [...status]
        statusAux[0] = 'NO AGREGADO'
        statusAux[1] = ''
        setStatus(statusAux)
        onError('ra.notification.created_error_add_items_reservation')
      }
      setLoadingItemsToBill(false)
    } else {
      setStatus(['', ''])
    }
    setErrorItems(false)
    setOpenConfirmationModal(false)
  }

  const handleClickUpdateItemsToBill = () => {
    if (updatingItemsToBill) {
      handleOpenConfirmationModal('update_items_title', handleConfirmItemsToBill)
    } else {
      setUpdatingItemsToBill(true)
      setImportingInvoice(false)
      setSelectedItemsToBill([])
    }
  }

  const handleClickUpdateItemsToDelete = () => {
    if (updatingItemsToDelete) {
      handleOpenConfirmationModal('delete_items_title', handleConfirmItemsToDelete)
    } else {
      setUpdatingItemsToDelete(true)
      setImportingInvoice(false)
      setSelectedItemsToBill([])
    }
  }

  const handleConfirmItemsToBill = async () => {
    setLoadingItemsToBill(true)
    const isBaseB = sale.find((elem) => elem.base === 'TIJEBERLIN') ? true : false
    const base_to_billing = getBaseToBilling(sale)
    const response = await reservationServices
      .updateItemsToBill(reservation.number, selectedItemsToBill, isBaseB, base_to_billing)
      .catch((error) => {
        setLoadingItemsToBill(false)
        addError(error, () => onError('ra.notification.updated_error_items_error'))
      })
    if (response) {
      setUpdatingItemsToBill(false)
      setSelectedItemsToBill([])
      getItems()
      onSuccess('ra.notification.updated_error_items_success')
    } else {
      onError('ra.notification.updated_error_items_error')
    }
    setLoadingItemsToBill(false)
    setOpenConfirmationModal(false)
  }

  const handleConfirmItemsToDelete = async () => {
    const formData = new FormData();
    for(let item of selectedItemsToBill){
      formData.append('hash_item', item);
    }
    setLoadingItemsToDelete(true)
    const response = await itemServices
      .updateItemsToDelete(formData)
      .catch((error) => {
        setLoadingItemsToDelete(false)
        addError(error, () => onError('ra.notification.delete_error_items_error'))
      })
    if (response) {
      setUpdatingItemsToDelete(false)
      setSelectedItemsToBill([])
      getItems()
      onSuccess('ra.notification.delete_error_items_success')
    } else {
      onError('ra.notification.delete_error_items_error')
    }
    setLoadingItemsToDelete(false)
    setOpenConfirmationModal(false)
  }

  const handleClickCancelItemsToBill = () => {
    if(updatingItemsToBill){
      setUpdatingItemsToBill(false)
      setImportingInvoice(false)
      setSelectedItemsToBill([])
    } else if(updatingItemsToDelete){
      setUpdatingItemsToDelete(false)
      setSelectedItemsToBill([])
    }
  }

  const handleClickImportInvoice = () => {
    if (importingInvoice) {
      handleOpenInvoiceModal()
    } else {
      setUpdatingItemsToBill(false)
      setImportingInvoice(true)
      setSelectedItemsToBill([])
    }
  }

  const handleSelectItemToBill = (item, checked) => {
    let selectedItemsAux = [...selectedItemsToBill]
    if (checked) {
      selectedItemsAux.push(item.hash_item)
    } else {
      selectedItemsAux = selectedItemsAux.filter((elem) => elem !== item.hash_item)
    }
    setSelectedItemsToBill(selectedItemsAux)
  }

  const handleClickUpdateInvoices = () => {
    if (updatingInvoices) {
      handleOpenConfirmationModal('update_items_title', handleConfirmUpdateInvoices)
    } else {
      setUpdatingInvoices(true)
      setSelectedInvoices([])
    }
  }

  const handleConfirmUpdateInvoices = async () => {
    setLoadingItemsToBill(true)
    setLoadingInvoices(true)
    const isBaseB = sale.find((elem) => elem.base === 'TIJEBERLIN') ? true : false
    const response = await reservationServices
      .updateItemsToBill(reservation.number, selectedInvoices, isBaseB)
      .catch((error) => {
        setLoadingItemsToBill(false)
        setLoadingInvoices(false)
        addError(error, () => onError('ra.notification.updated_error_items_error'))
      })
    if (response) {
      setUpdatingInvoices(false)
      setSelectedInvoices([])
      getItems()
      onSuccess('ra.notification.updated_error_items_success')
    } else {
      onError('ra.notification.updated_error_items_error')
    }
    setLoadingItemsToBill(false)
    setLoadingInvoices(false)
    setOpenConfirmationModal(false)
  }

  const handleClickCancelInvoices = () => {
    setUpdatingInvoices(false)
    setSelectedInvoices([])
  }

  const handleSelectInvoice = (item, checked) => {
    let selectedItemsAux = [...selectedInvoices]
    if (checked) {
      selectedItemsAux.push(item.hash_item)
    } else {
      selectedItemsAux = selectedItemsAux.filter((elem) => elem !== item.hash_item)
    }
    setSelectedInvoices(selectedItemsAux)
  }

  const getPostitle = (data) => {
    if (data?.items && data.items.length > 0) {
      const currency =
        data.items[0]?.currency && typeof data.items[0]?.currency === 'object'
          ? data.items[0]?.currency?.short_name
          : data.items[0]?.currency
      return (
        <Fragment>
          <b style={{ marginLeft: 20 }}>
            {translate('ra.field.total_amount_billing')}:{' '}
            <span className='blue'>
              {currency} {numberFormatterWithDecimalAndThousand(data?.total_amount)}
            </span>
          </b>
          <b style={{ marginLeft: 20 }}>
            {translate('ra.field.total_cost_billing')}:{' '}
            <span className='blue'>
              {currency} {numberFormatterWithDecimalAndThousand(data?.total_cost)}
            </span>
          </b>
        </Fragment>
      )
    }

    return null
  }

  const handleOpenInvoiceModal = () => {
    setOpenInvoiceModal(true)
    setInvoiceForm({document_branch_number:'22'})
  }

  const handleOpenCreditNoteModal = () => {
    setOpenCreditNoteModal(true)
    setCreditNoteForm({})
  }

  const handleChangeInvoiceData = (field, value) => {
    setInvoiceForm((current) => ({
      ...current,
      [field]: value,
    }))
  }

  const isDisableDeleteSaleButton = () => {
    return invoices.some((invoice) => {
      const checkItems = invoice.item.some((elem) => elem.status !== CANCELLED)
      return invoice.status !== CANCELLED || checkItems
    })
  }

  const handleConfirmDeleteInvoice = async (invoice) => {
    try {
      setLoadingInvoices(true)
      const invoiceResponse = await reservationServices.deleteInvoice(invoice.id)
      if (invoiceResponse) {
        getInvoices()
        onSuccess(
          isCreditNote(invoice)
            ? 'ra.notification.deleted_success_credit_note_reservation'
            : 'ra.notification.deleted_success_invoice_reservation'
        )
        return
      }
      onError(
        isCreditNote(invoice)
          ? 'ra.notification.deleted_error_credit_note_reservation'
          : 'ra.notification.deleted_error_invoice_reservation'
      )
    } catch (error) {
      onError(
        isCreditNote(invoice)
          ? 'ra.notification.deleted_error_credit_note_reservation'
          : 'ra.notification.deleted_error_invoice_reservation'
      )
      setLoadingInvoices(false)
    } finally {
      setOpenConfirmationModal(false)
    }
  }

  const isCreditNote = (invoice) => {
    try {
      if (
        NOTA_DE_CREDITO__A_ID == invoice?.voucher_type_id ||
        NOTA_DE_CREDITO__B_ID == invoice?.voucher_type_id
      ) {
        return true
      }
      return false
    } catch (error) {
      return false
    }
  }

  const handleClickDeleteInvoice = (invoice) => {
    setSelectedInvoices([])
    setUpdatingInvoices(false)
    handleOpenConfirmationModal(isCreditNote(invoice) ? 'delete_credit_note_title' : 'delete_invoice_title', () =>
      handleConfirmDeleteInvoice(invoice)
    )
  }

  const handleChangeSaleForm = (field, value) => {
    setSaleFormData((current) => ({
      ...current,
      [field]: value,
    }))
  }

  const tooltipContent = (
    <Typography>
      FA A &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; FACTURA A<br />
      FA B &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; FACTURA B<br />
      FA C &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; FACTURA C<br />
      FA E &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; FACTURA E<br />
      NC A &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NOTA DE CREDITO A<br />
      NC B &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NOTA DE CREDITO B Número de sucursal (22) <br />
      Nro de factura (12345)
    </Typography>
  )

  return (
    <Grid container spacing={1} className='billing_reservation'>
      <Grid item xs={12} lg={8}>
        <ShowCard title={translate('ra.title.pending_items')} posTitle={getPostitle(pendingItems)}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox
                      indeterminate={
                        selectedItems.length > 0 && selectedItems.length < pendingItems.items.length
                      }
                      checked={selectAll}
                      onChange={handleSelectAll}
                      style={{ padding: 0, width: 18 }}
                      disabled={loadingItems || !pendingItems?.items?.length}
                    />
                  </TableCell>
                  <TableCell>{translate('ra.field.type')}</TableCell>
                  <TableCell>{translate('ra.field.item_description')}</TableCell>
                  <TableCell>{translate('ra.field.locator')}</TableCell>
                  <TableCell>{translate('ra.field.currency')}</TableCell>
                  <TableCell>{translate('ra.field.total')}</TableCell>
                  <TableCell>{translate('ra.field.total_cost')}</TableCell>
                  <TableCell>{translate('ra.field.profit_percentage')}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loadingItems ? (
                  <TableRow>
                    {[...Array(8)].map((_, i) => (
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' width={'100%'} height={20} />
                      </TableCell>
                    ))}
                  </TableRow>
                ) : (
                  pendingItems?.items?.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Checkbox
                          style={{ padding: 0, width: 18 }}
                          onClick={(e) => handleSelectItem(row, e.target.checked)}
                          checked={selectedItems.find((elem) => elem.id === row?.id) ? true : false}
                          disabled={errorItems}
                        />
                      </TableCell>
                      <TableCell>{row?.service_type}</TableCell>
                      <TableCell>
                        {row?.description && Array.isArray(row?.description)
                          ? row?.description.join(' - ')
                          : row?.description}
                      </TableCell>
                      <TableCell>{row?.detail_code}</TableCell>
                      <TableCell>
                        {row?.currency && typeof row?.currency === 'object'
                          ? row?.currency?.short_name
                          : row?.currency}
                      </TableCell>
                      <TableCell>
                        <b>{numberFormatterWithDecimalAndThousand(row?.amount)}</b>
                      </TableCell>
                      <TableCell>
                        <b>{numberFormatterWithDecimalAndThousand(row?.billable_cost)}</b>
                      </TableCell>
                      <TableCell>
                        {numberFormatterWithDecimalAndThousand(row?.profit_percentage || 0)}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </ShowCard>

        <ShowCard
          title={translate('ra.title.items_to_bill')}
          posTitle={getPostitle(itemsToBill)}
          preActionButtonJustify='flex-end'
          preActionButton={
            <>
              {(updatingItemsToBill || updatingItemsToDelete) && itemsToBill?.items && itemsToBill?.items?.length > 0 && (
                <Button
                  variant='outlined'
                  size='small'
                  style={{ marginRight: 10 }}
                  onClick={handleClickCancelItemsToBill}
                  disabled={loadingItemsToBill || loadingItemsToDelete}
                >
                  {translate('ra.action.cancel')}
                </Button>
              )}
              {(!updatingItemsToDelete && itemsToBill?.items && itemsToBill?.items?.length > 0) && (
                <Button
                  variant='contained'
                  size='small'
                  startIcon={updatingItemsToBill ? <Save /> : <Edit />}
                  onClick={handleClickUpdateItemsToBill}
                  disabled={(updatingItemsToBill && selectedItemsToBill.length === 0) || loadingItemsToBill}
                >
                  {updatingItemsToBill ? translate('ra.action.to_confirm') : translate('ra.action.update')}
                </Button>
              )}
              {(hasPermissionFunction('itemBilling', 'delete') && !updatingItemsToBill && itemsToBill?.items && itemsToBill?.items?.length > 0) && (
                <Button
                  variant='contained'
                  size='small'
                  style={{marginLeft:'10px'}}
                  color='error'
                  startIcon={<Delete/>}
                  onClick={handleClickUpdateItemsToDelete}
                  disabled={(updatingItemsToDelete && selectedItemsToBill.length === 0) || loadingItemsToDelete}
                >
                  {updatingItemsToDelete ? translate('ra.action.to_confirm') : translate('ra.action.delete')}
                </Button>
              )}
            </>
          }
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {(updatingItemsToBill || importingInvoice || updatingItemsToDelete) && (
                    <TableCell>
                      <Checkbox
                        indeterminate={
                          selectedItemsToBill.length > 0 &&
                          selectedItemsToBill.length < itemsToBill.items.length
                        }
                        checked={selectAllToBill}
                        onChange={handleSelectAllToBill}
                        style={{ padding: 0, width: 18 }}
                        disabled={loadingItemsToBill}
                      />
                    </TableCell>
                  )}
                  <TableCell>{translate('ra.field.type')}</TableCell>
                  <TableCell>{translate('ra.field.item_description')}</TableCell>
                  <TableCell>{translate('ra.field.locator')}</TableCell>
                  <TableCell>{translate('ra.field.currency')}</TableCell>
                  <TableCell>{translate('ra.field.total')}</TableCell>
                  <TableCell>{translate('ra.field.total_cost')}</TableCell>
                  <TableCell>{translate('ra.field.num_item_billing')}</TableCell>
                  <TableCell>{translate('ra.field.base')}</TableCell>
                  <TableCell>{translate('ra.field.profit_percentage')}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loadingItemsToBill ? (
                  <TableRow>
                    {[...Array(updatingItemsToBill ? 10 : 9)].map((_, i) => (
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' width={'100%'} height={20} />
                      </TableCell>
                    ))}
                  </TableRow>
                ) : (
                  itemsToBill?.items?.map((row, i) => (
                    <TableRow key={i}>
                      {(updatingItemsToBill || importingInvoice || updatingItemsToDelete) && (
                        <TableCell>
                          <Checkbox
                            style={{ padding: 0, width: 18 }}
                            onClick={(e) => handleSelectItemToBill(row, e.target.checked)}
                            checked={selectedItemsToBill?.includes(row?.hash_item) ? true : false}
                          />
                        </TableCell>
                      )}
                      <TableCell>{row?.service_type}</TableCell>
                      <TableCell>
                        {row?.description && Array.isArray(row?.description)
                          ? row?.description.join(' - ')
                          : row?.description}
                      </TableCell>
                      <TableCell>{row?.detail_code}</TableCell>
                      <TableCell>
                        {row?.currency && typeof row?.currency === 'object'
                          ? row?.currency?.short_name
                          : row?.currency}
                      </TableCell>
                      <TableCell>
                        <b>{numberFormatterWithDecimalAndThousand(row?.amount)}</b>
                      </TableCell>
                      <TableCell>
                        <b>{numberFormatterWithDecimalAndThousand(row?.billable_cost)}</b>
                      </TableCell>
                      <TableCell>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                          {row?.erp_id}
                          <HasPermission resource={'itemBilling'} permission='edit'>
                            <EditIcon 
                              fontSize='small' 
                              color='info' 
                              style={{cursor:'pointer'}}
                              onClick={()=>{setBillingNumberModal(true); setItemIdToEdit(row.id)}}
                            />
                          </HasPermission>
                        </div>
                      </TableCell>
                      <TableCell>{row?.base}</TableCell>
                      <TableCell>
                        {numberFormatterWithDecimalAndThousand(row?.profit_percentage || 0)}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </ShowCard>

        <ShowCard
          title={translate('ra.title.generated_invoices')}
          className='generated_invoices'
          preActionButtonJustify='flex-end'
          preActionButton={
            <>
              {updatingInvoices && (
                <Button
                  variant='outlined'
                  size='small'
                  style={{ marginRight: 10 }}
                  onClick={handleClickCancelInvoices}
                >
                  {translate('ra.action.cancel')}
                </Button>
              )}
              {invoices.length > 0 && (
                <Button
                  variant='contained'
                  size='small'
                  startIcon={updatingInvoices ? <Save /> : <Edit />}
                  onClick={handleClickUpdateInvoices}
                  disabled={updatingInvoices && selectedInvoices.length === 0}
                >
                  {updatingInvoices ? translate('ra.action.to_confirm') : translate('ra.action.update')}
                </Button>
              )}
            </>
          }
        >
          {loadingInvoices ? (
            <Skeleton variant='rectangular' width={'100%'} height={100} />
          ) : (
            invoices.map((invoice, i) => (
              <ShowCard
                key={i}
                title={getInvoiceTitle(invoice)}
                className='invoice_card'
                buttonsFlex={0}
                preActionButtonJustify='flex-end'
                preActionButton={
                  <Button
                    variant='contained'
                    size='small'
                    color='error'
                    startIcon={<Delete />}
                    onClick={() => handleClickDeleteInvoice(invoice)}
                  >
                    {translate('ra.action.delete')}
                  </Button>
                }
              >
                {invoice.item?.map((item, j) => (
                  <Grid container spacing={2} key={j} className='fields'>
                    {updatingInvoices && (
                      <Grid item display={'flex'} alignItems={'center'}>
                        <Checkbox
                          style={{ padding: 0, width: 18 }}
                          onClick={(e) => handleSelectInvoice(item, e.target.checked)}
                          checked={selectedInvoices?.includes(item?.hash_item) ? true : false}
                        />
                      </Grid>
                    )}
                    <Grid item className='field'>
                      <span>{translate('ra.field.type')}</span>
                      <span className='value'>{item.service_type}</span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.item_description')}</span>
                      <span className='value'>
                        {item?.description && Array.isArray(item.description)
                          ? item.description.join(' - ')
                          : item.description}
                      </span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.locator')}</span>
                      <span className='value'>{item.detail_code}</span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.currency')}</span>
                      <span className='value'>{item.currency}</span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.total')}</span>
                      <span className='value'>{numberFormatterWithDecimalAndThousand(item.amount)}</span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.total_cost')}</span>
                      <span className='value'>
                        {numberFormatterWithDecimalAndThousand(item.billable_cost)}
                      </span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.num_item_billing')}</span>
                      <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                        <span className='value'>{item.erp_id}</span>
                        <HasPermission resource={'itemBilling'} permission='edit'>
                          <EditIcon 
                              fontSize='small' 
                              color='info' 
                              style={{cursor:'pointer'}}
                              onClick={()=>{setBillingNumberModal(true); setItemIdToEdit(item.id)}}
                            />
                        </HasPermission>
                      </div>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.base')}</span>
                      <span className='value'>{item.base}</span>
                    </Grid>
                    <Grid item className='field'>
                      <span>{translate('ra.field.profit_percentage')}</span>
                      <span className='value'>
                        {numberFormatterWithDecimalAndThousand(item.profit_percentage || 0)}
                      </span>
                    </Grid>
                  </Grid>
                ))}
              </ShowCard>
            ))
          )}
        </ShowCard>
        <HasPermission resource={'billing'} permission={'list_provider_order'}>
          <ShowCard
            title={translate('ra.title.reserve_requirement')}
            preActionButtonJustify='flex-end'
            preActionButton={<>
            <LoadingButton loading={orderRefrehLoading} onClick={getSupplierPaymentOrder}>
              <RefreshIcon/>
            </LoadingButton></>}
          >
              <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{translate('ra.field.date')}</TableCell>
                    <TableCell>{translate('ra.field.supplier')}</TableCell>
                    <TableCell>{translate('ra.field.currency')}</TableCell>
                    <TableCell>{translate('ra.field.amount')}</TableCell>
                    <TableCell>{translate('ra.title.observations')}</TableCell>
                    <TableCell>{translate('ra.title.actions')}</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                    {paymentsOrder?.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell>{parseDateFormat(row?.created_at)}</TableCell>
                        <TableCell>{row?.client_name}</TableCell>
                        <TableCell>{row?.currency}</TableCell>
                        <TableCell>{numberFormatterWithDecimalAndThousand(row?.amount || 0)}</TableCell>
                        <TableCell>{row?.message}</TableCell>
                        <TableCell>
                        <HasPermission resource={'billing'} permission={'delete_provider_order'}>
                          <Button
                              variant='outlined'
                              size='small'
                              onClick={()=>{setConfirmDeleteRequirement(true); setReqToDelete(row.id)}}
                            >
                              {translate('ra.action.delete')}
                            </Button>
                            </HasPermission>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      </Grid>

      <Grid item xs={12} lg={4} className='actions'>
        <ShowCard title={translate('ra.title.actions')}>
          <Grid container spacing={2} columns={24}>
            <Grid item xs={8}>
              {translate('ra.message.generate_client_title')}
            </Grid>
            <Grid item xs={7}>
              {client?.code || 'PENDIENTE'}
            </Grid>
            <Grid item xs={9} className='buttons-column'>
              <HasPermission resource={'sales'} permission={PERMISSION_CREATE}>
                <LoadingButton
                  loading={loadingClient}
                  size='small'
                  variant='contained'
                  disabled={Boolean(client)}
                  onClick={() => handleOpenConfirmationModal('generate_client_title', handleGenerateClient)}
                >
                  {client?.code ? translate('ra.action.generated') : translate('ra.action.generate')}
                </LoadingButton>
              </HasPermission>
            </Grid>

            <Grid item xs={15}>
              {translate('ra.title.generate_business_items')}
            </Grid>
            <Grid item xs={9} className='buttons-column'>
              <HasPermission resource={'sales'} permission={PERMISSION_CREATE}>
                <LoadingButton
                  loading={loadingClient || loadingSales || loadingItems}
                  size='small'
                  variant='contained'
                  className='full-process-button'
                  disabled={!Boolean(client) || (statusSale && Boolean(sale))}
                  onClick={() =>
                    setOpenBuisenessItemsConfirm(true)
                    
                  }
                >
                  {(!Boolean(client) || (statusSale && Boolean(sale)) )? translate('ra.action.generated') : translate('ra.action.initProcess')}
                </LoadingButton>
              </HasPermission>
            </Grid>

            <Grid item xs={15}>
              {translate('ra.field.billing_automatic')}
            </Grid>
            <Grid item xs={9} className='buttons-column'>
              <HasPermission resource={'sales'} permission={PERMISSION_CREATE}>
                <LoadingButton
                  loading={loadingClient || loadingSales || loadingItems}
                  size='small'
                  variant='contained'
                  disabled={!Boolean(client) || pendingItems?.items?.length === 0}
                  onClick={() =>
                    handleOpenCurrencyModal(
                      'init_complete_process',
                      (formData) => handleInitCompleteProcess(formData),
                      true
                    )
                  }
                >
                  {translate('ra.action.initCompleteProcess')}
                </LoadingButton>
              </HasPermission>
            </Grid>

            <Grid item xs={8}>
              {translate('ra.message.generate_sale_title')}
            </Grid>
            <Grid item xs={7}>
              {editBusinessNumber ?
              <TextField type='number' size='small' value={businessEditedNumber} onChange={(val)=>setBusinessEditedNumber(Number(val.target.value))} />:
              getSaleId()
              }
              {editBusinessNumber?
                <div style={{display:'flex', alignItems:'center', flexDirection:'row'}}>
                  <CloseIcon color='error' onClick={()=>setEditBusinessNumber(false)} style={{cursor:'pointer'}}/>
                  {editBusinessNumberLoading?
                    <CircularProgress size={'17px'} />
                  :
                  <DoneIcon style={{cursor:'pointer'}} color='success' onClick={onEditBusinessNumber}/>
                  }
                </div>
                 :
                ((businessEditedNumber == null && !loadingSales && sale?.length) &&
                  <HasPermission resource={'sales'} permission='edit'>
                    <EditIcon color='info' onClick={()=>setEditBusinessNumber(true)} fontSize='small' style={{/* marginLeft:'15px', */ marginRight:'15px',cursor:'pointer'}}/>
                  </HasPermission>
                )
              }
            </Grid>
            <Grid item xs={9} className='buttons-column'>
              <HasPermission resource={'sales'} permission={PERMISSION_CREATE}>
                {errorSale && !sale ? (
                  <LoadingButton
                    loading={loadingSales}
                    size='small'
                    variant='contained'
                    disabled={!Boolean(client)}
                    onClick={() =>
                      handleOpenConfirmationModal(
                        'confirm_creation_sale_title',
                        () => handleConfirmCreationSale(true),
                        () => handleConfirmCreationSale(false),
                        'confirm_creation_sale_content',
                        'ra.boolean.true',
                        'ra.boolean.false'
                      )
                    }
                  >
                    {translate('ra.action.to_confirm')}
                  </LoadingButton>
                ) : sale && hasPermissionFunction('sales', PERMISSION_DELETE) ? (
                  <LoadingButton
                    loading={loadingSales}
                    size='small'
                    variant='contained'
                    color='error'
                    disabled={isDisableDeleteSaleButton()}
                    onClick={() =>
                      handleOpenConfirmationModal(
                        'delete_sale_title',
                        handleDeleteSale,
                        null,
                        null,
                        null,
                        null,
                        true
                      )
                    }
                  >
                    {translate('ra.action.eliminate')}
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    loading={loadingSales}
                    size='small'
                    variant='contained'
                    disabled={!Boolean(client) || (statusSale && Boolean(sale))}
                    onClick={() =>
                      handleOpenCurrencyModal('generate_sale_title', (saleFormData) =>
                        handleGenerateSale(saleFormData)
                      )
                    }
                  >
                    {sale ? translate('ra.action.generated') : translate('ra.action.generate')}
                  </LoadingButton>
                )}
              </HasPermission>
            </Grid>

            <Grid item xs={8}>
              {translate('ra.message.add_items_title')}
            </Grid>
            <Grid item xs={7}>
              {status[0]}
            </Grid>
            <Grid item xs={9} className='buttons-column'>
              <HasPermission resource={'voucher'} permission={PERMISSION_CREATE}>
                {errorItems ? (
                  <LoadingButton
                    loading={loadingItemsToBill}
                    size='small'
                    variant='contained'
                    onClick={() =>
                      handleOpenConfirmationModal(
                        'confirm_add_items_title',
                        () => handleConfirmAddItems(true),
                        () => handleConfirmAddItems(false),
                        'confirm_add_items_content',
                        'ra.boolean.true',
                        'ra.boolean.false'
                      )
                    }
                    disabled={!Boolean(sale) || selectedItems.length === 0}
                  >
                    {translate('ra.action.to_confirm')}
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    loading={loadingItemsToBill}
                    size='small'
                    variant='contained'
                    onClick={() => handleOpenConfirmationModal('add_items_title', handleAddItem)}
                    disabled={!Boolean(sale) || selectedItems.length === 0}
                  >
                    {translate('ra.action.add')}
                  </LoadingButton>
                )}
              </HasPermission>
            </Grid>

            <Grid item xs={8}>
              {translate('ra.message.generate_invoice_title')}
            </Grid>
            <Grid item xs={7}>
              {status[1]}
            </Grid>
            <Grid item xs={9} className='buttons-column'>
              {importingInvoice && (
                <Button variant='outlined' size='small' onClick={handleClickCancelItemsToBill}>
                  {translate('ra.action.cancel')}
                </Button>
              )}
              <HasPermission resource={'voucher'} permission={PERMISSION_CREATE}>
                <LoadingButton
                  loading={loadingInvoices}
                  size='small'
                  variant='contained'
                  startIcon={importingInvoice ? <Save /> : null}
                  disabled={
                    importingInvoice &&
                    (selectedItemsToBill.length === 0 ||
                      loadingItemsToBill ||
                      !Boolean(sale) ||
                      !itemsToBill?.items ||
                      itemsToBill?.items?.length === 0)
                      ? true
                      : false
                  }
                  onClick={handleClickImportInvoice}
                >
                  {importingInvoice ? translate('ra.action.to_confirm') : translate('ra.action.import')}
                </LoadingButton>
              </HasPermission>
              {!importingInvoice && (
                <HasPermission resource={'voucher'} permission={'invoice'}>
                  <LoadingButton
                    loading={loadingInvoices}
                    size='small'
                    variant='contained'
                    disabled={
                      !Boolean(sale) || !itemsToBill?.items || itemsToBill?.items?.length === 0 ? true : false
                    }
                    onClick={handleOpenInvoiceModal}
                  >
                    {translate('ra.action.generate')}
                  </LoadingButton>
                </HasPermission>
              )}
            </Grid>
            <Grid item sm={15}>
              {translate('ra.message.generate_credit_note_title')}
            </Grid>
            <Grid item sm={9} className='buttons-column'>
              <HasPermission resource={'voucher'} permission={'credit_note'}>
                <LoadingButton
                  loading={loadingCreditNote}
                  size='small'
                  variant='contained'
                  disabled={!invoices?.length || !itemsToBill?.items || itemsToBill?.items?.length === 0 ? true : false}
                  onClick={handleOpenCreditNoteModal}
                >
                  {translate('ra.action.generate')}
                </LoadingButton>
              </HasPermission>
            </Grid>
          </Grid>
        </ShowCard>
        <ShowCard title={translate('ra.title.suppliers_actions')}>
          <HasPermission resource={'billing'} permission={'provider_order'}>
            <Grid container spacing={2} columns={24}>
              <Grid item xs={15}>
                {translate('ra.message.generate_supplier_payment_order')}
              </Grid>
              <Grid item xs={9} className='buttons-column'>
                <LoadingButton
                  /* loading={loadingInvoices} */
                  size='small'
                  variant='contained'
                  disabled = {getSaleId() === 'PENDIENTE'?true:false}
                  onClick={()=>setPaymentSupplierDialog(true)}
                >
                  {translate('ra.action.generate')}
                </LoadingButton>
              </Grid>
            </Grid>
          </HasPermission>
          </ShowCard>
      </Grid>

      <Confirm
        loading={loadingInvoices || loadingItemsToBill || loadingClient || loadingSales || loadingCreditNote || loadingItemsToDelete}
        isOpen={openConfirmationModal}
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {translate(`ra.message.${modalData.title}`)}
            {modalData.contentLogic && (
              <Tooltip title={translate('ra.message.delete_business_TMA_message')}>
                <InfoIcon
                  fontSize='small'
                  style={{ marginLeft: '8px', cursor: 'pointer', color: '#5663c9d1', fontSize: 14 }}
                />
              </Tooltip>
            )}
          </div>
        }
        content={
          modalData.contentLogic ? (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedDeleteBusinessInTMA}
                    onChange={(e) => setCheckedDeleteBusinessInTMA(e.target.checked)}
                    color='primary'
                  />
                }
                label={translate('ra.action.delete_business_in_tma')}
              />
              <Tooltip title={translate('ra.message.delete_business_action_TMA_message')}>
                <InfoIcon fontSize='small' style={{ cursor: 'pointer', color: '#5663c9d1', fontSize: 14 }} />
              </Tooltip>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                {translate(`ra.message.${modalData.content || 'confirm_action_content'}`)}
              </p>
            </div>
          ) : (
            `ra.message.${modalData.content || 'confirm_action_content'}`
          )
        }
        onConfirm={() =>
          modalData?.onConfirm
            ? modalData.contentLogic
              ? modalData.onConfirm(checkedDeleteBusinessInTMA)
              : modalData.onConfirm()
            : null
        }
        onClose={() => (modalData?.onClose ? modalData.onClose() : setOpenConfirmationModal(false))}
        cancel={modalData.cancelText || 'ra.action.cancel'}
        confirm={modalData.confirmText || 'ra.action.to_confirm'}
      />

      <Dialog className='sale-invoice-modal' open={openSaleModal} onClose={() => setOpenSaleModal(false)}>
        <DialogTitle>{translate(`ra.message.${modalData?.title}`)}</DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <EditInputsWrap
              label={translate('ra.field.currency')}
              required
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <Select
                fullWidth
                onChange={(e) => handleChangeSaleForm('currency', e.target.value)}
                value={saleFormData?.currency || ''}
                size='small'
              >
                <MenuItem value='ARS'>ARS</MenuItem>
                <MenuItem value='USD'>USD</MenuItem>
              </Select>
            </EditInputsWrap>
            {/* <EditInputsWrap label={translate('ra.field.is_berlin')} md={12} lg={12} style={{ minHeight: 0 }}>
              <SwitchInput
                value={saleFormData?.isBerlin || false}
                onChange={(value) => handleChangeSaleForm('isBerlin', value)}
              />
            </EditInputsWrap> */}
            {!modalData?.autoBill && (
              <EditInputsWrap
                label={translate('ra.field.sale_number')}
                md={12}
                lg={12}
                style={{ minHeight: 0 }}
              >
                <TextField
                  value={saleFormData?.saleNumber || ''}
                  onChange={(e) => handleChangeSaleForm('saleNumber', e.target.value)}
                  size='small'
                  fullWidth
                />
              </EditInputsWrap>
            )}
            <EditInputsWrap
              label={translate('ra.field.billing_base')}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              {loadingBasesList ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <Autocomplete
                  fullWidth
                  size='small'
                  options={basesList?.options}
                  value={saleFormData?.baseToBilling || ''}
                  onChange={(e, value) => handleChangeSaleForm('baseToBilling', value)}
                  renderInput={(params) => <TextField {...params} />}
                />
              )}
            </EditInputsWrap>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setOpenSaleModal(false)}>
            Cancelar
          </Button>
          <LoadingButton
            loading={loadingInvoices || loadingItemsToBill || loadingClient || loadingSales}
            size='small'
            variant='contained'
            disabled={!saleFormData?.currency}
            onClick={() =>
              handleOpenConfirmationModal(modalData?.title, () => modalData?.onConfirm(saleFormData))
            }
          >
            {translate('ra.action.continue')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
      
      <Dialog className='sale-invoice-modal' open={paymentSupplierDialog} onClose={() => setPaymentSupplierDialog(false)}>
        <DialogTitle>
          {translate(`ra.title.payment_order_requirement`)}
        </DialogTitle>
        <DialogContent>
            <PaymentSupplierDialog businessUnitId ={reservation?.business_unit_id} items={reservation?.items} setPaymentSupplierDialog={setPaymentSupplierDialog}/>
        </DialogContent>
      </Dialog> 

      <Dialog className='sale-invoice-modal' open={billingNumberModal} onClose={() => setBillingNumberModal(false)}>
        <DialogTitle>
          {translate(`ra.title.billing_number`)}
        </DialogTitle>
        <DialogContent>
            <BillingNumberDialog setReloadItemsToBill={setReloadItemsToBill} setBillingNumberModal={setBillingNumberModal} itemIdToEdit={itemIdToEdit}/>
        </DialogContent>
      </Dialog> 

      <Dialog
        fullWidth
        maxWidth='sm'
        className='sale-invoice-modal'
        open={openInvoiceModal}
        onClose={() => setOpenInvoiceModal(false)}
      >
        <DialogTitle>
          {importingInvoice
            ? translate('ra.message.import_invoice_title')
            : translate('ra.message.generate_invoice_title')}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            {importingInvoice && (
              <EditInputsWrap
                label={`${translate('ra.field.invoice_reference')} (${translate(
                'ra.message.optional'
              )})`}
                md={12}
                lg={12}
                style={{ minHeight: 0 }}
                tooltiptext={tooltipContent}
              >
                <TextField
                  value={invoiceForm?.invoice_reference || ''}
                  onChange={(e) => handleChangeInvoiceData('invoice_reference', e.target.value)}
                  label={'FA A 22-12345'}
                  size='small'
                  sx={{
                    width: { xs: '100%', sm: '50%' },
                    '& legend': { display: 'none' },
                    '& .MuiInputLabel-shrink': { opacity: 0, transition: 'all 0.2s ease-in' },
                  }}
                />
              </EditInputsWrap>
            )}
            <EditInputsWrap
              label={`CAE (${translate(
                'ra.message.optional'
              )})`}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={invoiceForm?.CAE || ''}
                onChange={(e) => handleChangeInvoiceData('CAE', e.target.value)}
                size='small'
                sx={{ width: { xs: '100%', sm: '50%' } }}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={`${translate('ra.field.differentiated_change_type')} (${translate(
                'ra.message.optional'
              )})`}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={invoiceForm?.currency_value || ''}
                onChange={(e) => handleChangeInvoiceData('currency_value', e.target.value)}
                size='small'
                type='number'
                sx={{ width: { xs: '100%', sm: '50%' } }}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={`${translate('ra.field.text')} (${translate('ra.message.optional')})`}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={invoiceForm?.glosa || ''}
                onChange={(e) => handleChangeInvoiceData('glosa', e.target.value)}
                size='small'
                fullWidth
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={`${translate('ra.field.document_branch_number')} (${translate('ra.message.optional')})`}
              md={12}
              lg={12}
              style={{ minHeight: 0 }}
            >
              <TextField
                value={invoiceForm?.document_branch_number || ''}
                onChange={(e) => handleChangeInvoiceData('document_branch_number', e.target.value)}
                size='small'
                type='number'
                fullWidth
              />
            </EditInputsWrap>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setOpenInvoiceModal(false)}>
            {translate('ra.action.cancel')}
          </Button>
          <LoadingButton
            loading={loadingInvoices || loadingItemsToBill || loadingClient || loadingSales}
            size='small'
            variant='contained'
            disabled={importingInvoice && (!invoiceForm?.invoice_reference && !invoiceForm?.CAE)}
            onClick={() =>
              handleOpenConfirmationModal(
                importingInvoice ? 'import_invoice_title' : 'generate_invoice_title',
                handleGenerateInvoiceAux
              )
            }
          >
            {translate('ra.action.continue')}
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <CreditNote
        reservation={reservation}
        handleOpenConfirmationModal={handleOpenConfirmationModal}
        setOpenCreditNoteModal={setOpenCreditNoteModal}
        openCreditNoteModal={openCreditNoteModal}
        setOpenConfirmationModal={setOpenConfirmationModal}
        creditNoteForm={creditNoteForm}
        setCreditNoteForm={setCreditNoteForm}
        loadingCreditNote={loadingCreditNote}
        setLoadingCreditNote={setLoadingCreditNote}
        invoices={invoices}
        setInvoices={setInvoices}
      />
      <ConfirmationDialog
        contentText = {translate('ra.message.delete_requirement')}
        buttonConfirmText={translate('ra.action.to_confirm')}
        buttonCancel={translate('ra.action.cancel')}
        setOpen={setConfirmDeleteRequirement}
        loadingModalButton={loadingDeleteReq}
        setConfirm = {setConfirmDeleteReq}
        open = {confirmDeleteRequirement}
      />

      <ConfirmationDialog
        contentText = {translate('ra.message.init_process_confirmation')}
        buttonConfirmText={translate('ra.action.to_confirm')}
        buttonCancel={translate('ra.action.cancel')}
        setOpen={setOpenBuisenessItemsConfirm}
        loadingModalButton={businessItemsLoading}
        setConfirm = {setBusinessItemsConfirm}
        open = {openBusinessItemsConfirm}
      />
    </Grid>
  )
}
